export default {"src":"/login-app/[GIT_HASH]/_next/static/media/hourglass_bottom.10d12171.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};